import React, { useState } from 'react'
import { Input } from '../../components/Input'
import { Text } from '../../components/Text'
import { Helmet } from 'react-helmet'
import sign from '../../assets/img/sign-image.png'
import logo from '../../assets/img/cell-logo.png'
import tick from '../../assets/img/icon/tick.png'
import check from '../../assets/img/icon/check.png'
import { useNavigate } from 'react-router-dom'

const SignUp = () => {
  const navigate = useNavigate()
  const callHome = () => {
    navigate('/')
    window.scrollTo(0, 0)
  }
  const [checked, onChecked] = useState(false)
  const selectCheck = () => {
    if (checked) {
      onChecked(false)
    } else {
      onChecked(true)
    }
  }

  return (
    <>
      <Helmet>
        <title>cellbank</title>
        <meta name='description' content='cell bank ' />
      </Helmet>
      <div className=' h-full maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mobile:w-full'>
        <div className='flex flex-row justify-between mobile:justify-center'>
          <div className='flex flex-col items-start justify-between py-20 px-10 h-[100vh] mobile:px-5 mobile:py-5'>
            <img
              className='h-[2.25rem] w-[22%] object-contain'
              alt='logo'
              src={logo}
              onClick={callHome}
            ></img>
            <div className='mx-[2.38rem] flex flex-col gap-[1.88rem] self-stretch md:mx-0  p-20 mobile:p-2 mobile:mx-0'>
              <div className='flex flex-col items-start gap-[0.88rem]'>
                <h1
                  className='text-[28px] font-bold'
                >
                  Тавтай морил
                </h1>
                <p
                  className='text-[16px] text-[#475467]'
                >
                  Нэвтрэх нэр болон нууц үг оруулна уу
                </p>
              </div>
              <div className='flex flex-col gap-[1.38rem] self-stretch w-full max-w-[28.5rem]'>
                <div className='flex flex-col gap-[1.25rem]'>
                  <Input
                    shape='round'
                    name='label'
                    placeholder='Нэвтрэх нэр'
                    className='w-[26rem] max-w-full rounded-[12px] border border-solid border-indigo-100 px-[1.25rem]  mobile:w-full'
                  />
                  <Input
                    shape='round'
                    type='password'
                    name='label'
                    placeholder='Нууц үг'
                    className='w-[26rem] max-w-full rounded-[12px] border border-solid border-indigo-100 px-[1.25rem]   mobile:w-full'
                  />
                </div>
                <div className='flex flex-row items-start justify-between text-black gap-[1.00rem]'>
                  <div className='flex flex-row items-start'>
                    <img
                      className='h-6 w-6'
                      src={checked ? check : tick}
                      onClick={selectCheck}
                      alt='2'
                    ></img>
                    <p className='ml-2 text-[14px] text-[#344054]'>Сануулах</p>
                  </div>
                  <a href='signup' className='flex items-end  text-[14px] text-[#215998]'>Нууц үгээ мартсан уу?</a>
                </div>
                <div className='flex flex-col items-start gap-[1.00rem]'>
                  <button className='w-full max-w-[26rem] rounded-[12px] px-[2.13rem] font-sfpro font-medium h-[3.00rem] text-[0.88rem] bg-blue-900 text-white'>
                    Нэвтрэх
                  </button>
                  <div className='flex items-center justify-center gap-[1.00rem] self-stretch'>
                    <div className='h-[0.06rem] w-[34%] bg-indigo-50' />
                    <Text
                      size='body_body______large'
                      as='p'
                      className='font-sfpro text-[1.00rem] font-normal text-blue_gray-780'
                    >
                      Эсвэл
                    </Text>
                    <div className='h-[0.06rem] w-[34%] bg-indigo-50' />
                  </div>
                  <button className='w-full max-w-[26rem] gap-[8.75rem] rounded-[12px] border border-solid border-blue_gray-108 px-[2.86rem]  font-medium h-[2.75rem] text-[1.0rem]'>
                    Бүртгүүлэх
                  </button>
                  {/* <button className='w-full max-w-[26rem] gap-[8.75rem] rounded-[12px] border border-solid border-blue_gray-108 px-[2.86rem]  font-medium h-[2.75rem] text-[1.0rem]'>

                    Facebook - ээр нэвтрэх
                  </button> */}
                </div>
              </div>
            </div>
            <p
              className='text-[14px] text-[#475467] '
            >
              │© Cellclinic 2024
            </p>
          </div>
          <div className='h-[100vh] mobile:hidden'>
            <img
              className='py-20 '
              src={sign}
              alt='Cede'
              style={{ height: '100%', width: '100%' }}
            ></img>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignUp
